import React from "react";
import BaseLayout from "../../templates/BaseLayout/BaseLayout";
import CourseListSubmoduleCoursesManagerTemplate from "../../templates/courseListSubmoduleCoursesManagerTemplate/CourseListSubmoduleCoursesManagerTemplate";

export default function CourseListSubmoduleCoursesManagerPage() {
    return (
        <BaseLayout currentKey="CourseListSubmoduleCoursesManager" content={<CourseListSubmoduleCoursesManagerTemplate />} />
    );
}